import { render, staticRenderFns } from "./ReferFriendsView.vue?vue&type=template&id=f20103a6&scoped=true&"
import script from "./ReferFriendsView.vue?vue&type=script&lang=js&"
export * from "./ReferFriendsView.vue?vue&type=script&lang=js&"
import style0 from "./ReferFriendsView.vue?vue&type=style&index=0&id=f20103a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20103a6",
  null
  
)

export default component.exports